module.exports = __webpack_public_path__ + "img/87.5.COD.196f3b6d.png";